import React from "react";
import { Tooltip } from "antd";
import {
  EMPTY_CELL_VALUE,
  OVERDUE_PHASE_LABELS,
  formatOverdueCellValue,
  resolveOverdueReasonDisplayLabel,
} from "./utils/overdueUtils";
import { resolveRetestCustomerCompanyName } from "./utils/retestUtils";

function TooltipIfLong({ value }) {
  const displayValue = String(value ?? EMPTY_CELL_VALUE);
  return (
    <Tooltip placement="topLeft" title={displayValue}>
      <span className="Sample__Modal__HeaderValue DataOpsAnalytics__HeaderValueEllipsis">
        {displayValue}
      </span>
    </Tooltip>
  );
}

/**
 * Labeled Sample__Modal header used by Data Ops drill-down / detail modals.
 * @param {{ label: string, value: * }[]} items
 */
export default function DataOpsSampleModalHeader({ items }) {
  const headerItems = Array.isArray(items) ? items.filter(Boolean) : [];
  if (!headerItems.length) {
    return null;
  }

  return (
    <div className="Sample__Modal__Header">
      {headerItems.map((item, index) => (
        <React.Fragment key={item.label}>
          {index > 0 && <div className="Sample__Modal__HeaderDivider" />}
          <div className="Sample__Modal__HeaderItem">
            <div>
              <span className="Sample__Modal__HeaderLabel">{item.label}</span>
              <TooltipIfLong value={item.value} />
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export const buildOverdueRowHeaderItems = (record, reasonLabelById = null) => {
  if (!record) {
    return [];
  }

  const items = [
    { label: "Customer", value: formatOverdueCellValue(record.customer_id) },
    { label: "Test Category", value: formatOverdueCellValue(record.category_name) },
    { label: "Test Name", value: formatOverdueCellValue(record.test_name) },
    {
      label: "Phase",
      value: OVERDUE_PHASE_LABELS[record.phase] || formatOverdueCellValue(record.phase),
    },
    {
      label: "Overdue Reason",
      value: resolveOverdueReasonDisplayLabel(record, reasonLabelById),
    },
  ];

  if (record.is_retest) {
    items.push({ label: "Retest", value: "Yes" });
  }

  return items;
};

export const buildRetestRowHeaderItems = (record, customerLookup = null) => {
  if (!record) {
    return [];
  }

  const customerName = resolveRetestCustomerCompanyName(record, customerLookup);

  return [
    {
      label: "Customer",
      value: formatOverdueCellValue(customerName || record.customer_id),
    },
    { label: "Customer ID", value: formatOverdueCellValue(record.customer_id) },
    { label: "GBID", value: formatOverdueCellValue(record.original_wo_gbid) },
    { label: "Sample Type", value: formatOverdueCellValue(record.sample_type) },
    { label: "Test Name", value: formatOverdueCellValue(record.test_name) },
    { label: "Retest Reason", value: formatOverdueCellValue(record.retest_reason) },
  ];
};
